import React from 'react'
import styled from 'styled-components'

const A = styled.a`
  color: white;
  text-decoration: none;
  &:hover {
    background: white;
    color: black;
  }
`

export default A